import { render, staticRenderFns } from "./MigrasiData.vue?vue&type=template&id=9fee77b4&scoped=true"
import script from "./MigrasiData.vue?vue&type=script&lang=js"
export * from "./MigrasiData.vue?vue&type=script&lang=js"
import style0 from "./MigrasiData.vue?vue&type=style&index=0&id=9fee77b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fee77b4",
  null
  
)

export default component.exports